<template>
    <li class="right-side onhover-dropdown">
        <div class="delivery-login-box">
            <div class="delivery-icon">
                <i data-feather="user"></i>
            </div>
            <div class="delivery-detail" v-if=" ! auth.isLoggedIn()" >
                <h6>{{ $t('Hello') }},</h6>
                <h5>{{ $t('My Account')}}</h5>
            </div>
            <div class="delivery-detail" v-else >
                <h6>{{ $t('Hello') }},</h6>
                <h5>{{ auth.user('name') }}</h5>
            </div>
        </div>

        <div class="onhover-div onhover-div-login">
            <ul class="user-box-name"  v-if=" ! auth.isLoggedIn()" >
                <li class="product-box-contain">
                    <i></i>
                    <router-link :to="{ name:'login', params: { lang : $i18n.locale } }" >{{ $t('Sign in')}}</router-link>
                </li>
                <li class="product-box-contain">
                    <router-link :to="{ name:'register', params: { lang : $i18n.locale } }" >{{ $t('Sign Up')}}</router-link>
                </li>
                <li class="product-box-contain">
                    <router-link :to="{ name:'password.reset', params: { lang : $i18n.locale } }"  class="forgot-password">
                        {{  $t('Forgot Password?') }}
                    </router-link>
                </li>
            </ul>
            <ul class="user-box-name"  v-else>
                <li class="product-box-contain" v-if=" ! auth.user('verified')" >
                    <i></i>
                    <router-link :to="{'name' : 'activation', params: { lang : $i18n.locale }}">
                        {{ $t('Activate your membership') }}
                    </router-link>
                </li>
                <li class="product-box-contain">
                    <a href="#">أهلاً بك {{ auth.user('name')}}</a>
                </li>
                <li class="product-box-contain">
                    <router-link :to="{ name: 'users.edit', params: { lang : $i18n.locale } }" >
                        تغيير بياناتي
                    </router-link>
                </li>

                <li class="product-box-contain">
                    <router-link :to="{ name: 'users.change_password', params: { lang : $i18n.locale } }" >
                        {{ $t('Change password')}}
                    </router-link>
                </li>
<!--                <li class="product-box-contain">-->
<!--                    <router-link :to="{ name: 'addresses.index', params: { lang : $i18n.locale } }" >-->
<!--                        {{ $t('Addresses')}}-->
<!--                    </router-link>-->
<!--                </li>-->

                <li class="product-box-contain" v-if="auth.user('is_driver') === true">
                    <a href="/drivers" target="_blank">
                        لوحة تحكم السائق
                    </a>
                </li>

                <li class="product-box-contain" v-if="auth.user('is_vendor') === true">
                    <a href="/suppliers" target="_blank">
                        لوحة تحكم المحل
                    </a>
                </li>

                <li class="product-box-contain">
                    <router-link :to="{ name: 'orders.index', params: { lang : $i18n.locale } }" >
                        {{ $t('Your Orders')}}
                    </router-link>
                </li>
                <li class="product-box-contain">
                    <a href="#" class="" @click="auth.logout()" >{{ $t('Log out') }}</a>
                </li>
            </ul>
        </div>
    </li>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    inject: ['auth'],
    watch: {
        '$userLoggedIn.value': function (newVal) {
            if(newVal === true){


                const cartItems = this.$user.value?.cart_items ?? [];
                // console.log( '--- cartItems' );
                // console.log( this.$user.value.cart_items );
                // console.log( cartItems );
                //
                // console.log('Type of cartItems:', typeof cartItems);
                // console.log('cartItems:', cartItems);
                const productsArray = Object.values(cartItems);

                productsArray?.forEach(product => {
                    this.autoAddToCart(product);
                });
            }
        },
    },
    computed: {
        ...mapGetters(['cartItems']), // Map the cartItems getter
        total() {
            return this.cartItems.reduce((total, product) => total + (product?.cart?.quantity || 0) * product.price, 0);
        },
    },
    methods: {
        ...mapActions(['addToCart', 'removeFromCart','autoAddToCart']), // Map the addToCart and removeFromCart actions
        // Your other methods here
    },
};

</script>

<style scoped>
/* Add your component-specific styles here */
</style>
